// extracted by mini-css-extract-plugin
export default {"periods":"DatePeriodPicker_periods__gpV5B"};